import Vue from "vue";

const methods = {
  formatTime: time => {
    const minutes = Math.floor(time / 60);
    const seconds = time - minutes * 60;
    return `${String(minutes).length < 2 ? `0${minutes}` : minutes} : ${
      String(seconds).length < 2 ? `0${seconds}` : seconds
    }`;
  }
};

Vue.prototype.$_formatTime = methods.formatTime;
